import React, { Component } from 'react';

export class TermsOfService extends Component {

    render() {
        return (
            <div>
                <h3>Phoenix Terms Of Service</h3>
            </div>
        );
    }
}